<template>
    <div class="row mt-3 mb-3">
        <div class="col-sm-12 col-lg-8 my-2 my-lg-0">
            <div class="card border" style="height: 100%">
                <div class="card-header border-0">
                    <div class="d-flex justify-content-between">
                        <h3 class="card-title m-0">Make Payment</h3>
                    </div>
                </div>
                <div class="card-body">
                    <table class="payments">
                        <th></th>
                        <tr>
                            <td>
                                <h3 class="m-0">
                                    <strong><input type="radio" name="payment_amount_type"
                                            v-model="form.payment_amount_type" value="due" id="payment_amount_type_due"
                                            class="form-check-input" />
                                        <label class="form-check-label" for="payment_amount_type_due"> Due
                                            Now</label></strong>
                                </h3>
                            </td>
                            <td>
                                <h3 class="m-0">
                                    <strong>{{ formatDollars(payment.dueTotal) }}</strong>
                                </h3>
                            </td>
                        </tr>
                        <tr v-if="payment.unpaidTotal != payment.dueTotal">
                            <td>
                                (+ Due Soon)
                            </td>
                            <td>
                                {{ formatDollars(payment.unpaidTotal - payment.dueTotal) }}
                            </td>
                        </tr>
                        <tr v-if="payment.unpaidTotal != payment.dueTotal">
                            <td>
                                <strong>
                                    <input type="radio" name="payment_amount_type" v-model="form.payment_amount_type"
                                        value="total" id="payment_amount_type_total" class="form-check-input" />
                                    <label class="form-check-label" for="payment_amount_type_total"> Total Charges</label>
                                </strong>
                            </td>
                            <td>
                                <strong>{{ formatDollars(payment.unpaidTotal) }}</strong>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="mb-3">
                                    <input type="radio" name="payment_amount_type" v-model="form.payment_amount_type"
                                        value="other" id="payment_amount_type_other" class="form-check-input"
                                        @click="otherClick()" />
                                    <label class="form-check-label" for="payment_amount_type_other"> Other Amount</label>
                                </div>
                            </td>
                            <td>
                                <AmountInput v-model="form.payment_amount" ref="payment_amount" class="form-money"
                                    @input="typeOther" />
                            </td>
                        </tr>
                    </table>

                    <SelectAccount :banks="payment.banks" :link_token="link_token" :form="form" bankRoute="mtd.cart.addBank"
                        :form_bank="formBank" :bank_discount_percent="payment.bank_discount_percent"
                        @setPaymentMethod="setPaymentMethod" @bankAdded="updateSelected" />
                    <div class="row" v-if="payment.bank_discount_percent && paymentAmount > 0">
                        <div class="alert alert-success col-lg-6">
                            <div class="" v-if="payment.banks.length == 0">Add a bank and save...</div>
                            <div v-else>Save using bank account</div>
                            <ul class="list-unstyled">
                                <li class="d-flex justify-content-between align-items-end mt-2 pt-2 border-top">
                                    <strong>Payment Amount</strong>
                                    <h5 class="text-success mb-0">{{ formatDollars(paymentAmount) }}</h5>
                                </li>
                                <li class="d-flex justify-content-between"><strong>ACH Discount</strong><span
                                        class="text-secondary">-{{ formatDollars(paymentAmount *
                                            (payment.bank_discount_percent / 100)) }}</span></li>

                                <li class="d-flex justify-content-between align-items-end mt-2 pt-2 border-top"><strong>Your
                                        Charge</strong>
                                    <h5 class="text-success mb-0">{{ formatDollars(paymentAmount - (paymentAmount *
                                        (payment.bank_discount_percent / 100))) }}</h5>
                                </li>
                            </ul>

                        </div>
                    </div>
                    <SelectCard :cards="payment.cards" class="mt-3 clear-fix" :form="form" @setPaymentMethod="setPaymentMethod" />

                    <div class="bottom-button pt-3 mt-2 border-top">
                        <jet-button class="px-5" btnStyle="success" :disable="form.processing"
                            @click="completeCheckout()">Submit</jet-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <AddCard :routeUrl="route('mtd.cart.addCard')" :formCard="formCard" @cardUpdated="updateSelected" />
</template>

<script>
import AppLayout from '@/Layouts/AppLayout'
import FlashMessages from '@/Shared/FlashMessages'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetDangerButton from '@/Jetstream/DangerButton'
import toastr from 'toastr'
import moment from 'moment'
import SelectAccount from '@/Components/Payment/SelectAccount'
import SelectCard from '@/Components/Payment/SelectCard'
import AddCard from '@/Components/Modals/AddCard'
import AmountInput from '@/Shared/AmountInput'

export default {
    components: {
        AppLayout,
        FlashMessages,
        JetDialogModal,
        JetDangerButton,
        AddCard,
        SelectAccount,
        SelectCard,
        AmountInput
    },
    props: {
        payment: Object,
    },
    data() {
        return {
            link_token: this.payment.link_token,
            bankProcessing: false,
            cardProcessing: false,
            form: this.$inertia.form({
                payment_amount_type: 'due',
                payment_intent: this.payment.payment_intent,
                payment_amount: null,
                stripe_payment_method: this.payment.payment_method_id
            }),
            formCard: this.$inertia.form({
                card_name: null,
                card_number: null,
                card_exp_month: null,
                card_exp_year: null,
                card_cvc: null,
                card_zip: null,
            }),
            formBank: this.$inertia.form({
                public_token: null,
                account_id: null
            }),
        }
    },
    created() {
        this.moment = moment;
    },
    methods: {
        deleteCard(card) {
            this.cardProcessing = true
            this.$inertia.visit(route('cart.deleteMethod', card), {
                onSuccess: () => this.cardProcessing = false,
                onFinish: () => this.cardProcessing = false
            })
        },
        typeOther() {
            this.form.payment_amount_type = 'other';
        },
        otherClick() {
            this.$refs.payment_amount.$refs.amount_input.focus()
        },
        setPaymentMethod(e, id, type) {
            if (e.target.checked) {
                this.form.stripe_payment_method = id;
                this.form.payment_intent = type;
            }
        },
        completeCheckout() {
            if (!this.form.stripe_payment_method) {
                toastr.error("Please select a payment method");
            } else if (this.payment_amount_type == 'other' &&
                parseFloat(this.payment_amount) < 10) {
                toastr.error("Please select a payment amount - minimum is $10");
            } else {
                this.form.post(this.route('mtd.payment.submit'));
            }
        },
        updateSelected() {
            this.form.stripe_payment_method = this.payment.payment_method_id;
        },
    },
    computed: {
        paymentAmount() {
            switch (this.form.payment_amount_type) {
                case 'due':
                    return this.payment.dueTotal;
                case 'total':
                    return this.payment.unpaidTotal;
                case 'other':
                    if (parseFloat(this.form.payment_amount) > 0) {
                        return this.form.payment_amount;
                    }
            }
            return 0;
        }
    }
}
</script>

<style>
div.form-money {
    width: 150px !important;
}

table.payments td {
    vertical-align: middle;
    padding-bottom: 5px;
    padding-top: 5px;
    padding-left: 25px;
}</style>
